<template>
<div>
    <section v-for="categoria in categorias" v-bind:key="categoria">
          <h2 class="titulo" v-bind:class="categoria + '-texto'">
            <img
              v-bind:src="'//www.lefrank.com.br/img/icone-'+categoria+'.png'"
              height="19px"
            />
            {{ categoria.toUpperCase() }} →
          </h2>
          <section class="artigos">
            <section v-for="artigo in json" v-bind:key="artigo.id">
              <section v-if="artigo.categoria === categoria" class="card"
                v-bind:style="{ 'background-image': 'linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(0,0,0,0.8) 100%), url(' + artigo.img + ')' }"
              >
            <router-link :to="{path: '/artigo/' + artigo.id}">
                <section class="conteudo">
                  <section class="resumo">
                    <p>{{ artigo.titulo }}</p>
                    <span>
                      {{ artigo.descricao }}
                    </span>
                  </section>
                  <section class="comentarios" v-bind:class="artigo.categoria">
                    <img
                      src="//www.lefrank.com.br/img/icons/Image%201515.png" 
                    />
                    <b>{{ artigo.comentarios }}</b>
                  </section>
                  <section class="comentarios" v-bind:class="artigo.categoria" style="margin-left: 5px">
                    <img
                      src="//lefrank.com.br/img/icons/new_19.gif" width="7px"
                    />
                    <b>{{ artigo.views }}</b>
                  </section>
                  <section
                    class="autor"
                    v-bind:style="{ 'background-image': 'url(https://www.habbo.com.br/habbo-imaging/avatarimage?hb=image&user=' + artigo.autor + '&headonly=0&direction=4&head_direction=3&action=&gesture=sml&size=m)' }"
                  ></section>
                  <li v-bind:class="artigo.categoria">{{ artigo.autor }}</li>
                </section>
           </router-link>
              </section>
            </section>
          </section>
        </section>
</div>
</template>

<script>

export default {
  name: "Artigos",
  data: () => ({
    json: {}, categorias: ['le-frank', 'habbo', 'tutoriais', 'mundo', 'comunidade', 'moda']
  }),
  created: function() {
    fetch('https://api.lefrank.com.br/artigos').then((response) => {
      return response.json().then((json) => {
        this.json = json
      })
    })
  }
};
</script>

<style scoped>
.artigos {
  display: flex;
  width: 100%;
  height: 220px;
  overflow-x: auto;
  overflow-y: hidden;
  margin: 0 auto;
  -webkit-overflow-scrolling: touch;
  font-family: 'Krub', sans-serif;
  font-weight: 600;
}

.artigos .card {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 10px;
  margin: 10px 5px;
  padding: 10px;
  min-width: 280px;
  max-width: 280px;
  height: 190px;
  display: inline-block;
}

.artigos .card:nth(first) {
  margin-left: 10px;
}

.artigos .card:nth(last) {
  margin-right: 10px;
}

.artigos .card .conteudo {
  margin: 0 auto;
  width: inherit;
  height: inherit;
  float: left;
}

.artigos .card .conteudo .resumo {
  width: inherit;
  height: 120px;
}

.artigos .card .conteudo .resumo p {
  font-size: 1rem;
  width: inherit;
  font-weight: 700;
  color: white;
  margin: 0;
  padding: 7px 7px 0 7px;
  float: left;
}

.artigos .card .conteudo .resumo span {
  font-size: 0.875rem;
  width: inherit;
  font-weight: 300;
  color: white;
  margin: 0;
  padding: 0 7px;
  float: left;
}

.artigos .card .conteudo .comentarios {
  list-style-type: none;
  padding: 3px 7px;
  font-size: 0.8175rem;
  color: white;
  font-weight: 600;
  float: left;
  box-shadow: 0 1px 1px rgba(0,0,0,0.4);
  border-radius: 5px;
  margin-top: 49px;
  
}

.artigos .card .conteudo .autor {
  width: 64px;
  height: 87px;
  float: right;
  margin-top: -7px;
  margin-right: -10px;
}

.artigos .card .conteudo li {
  list-style-type: none;
  float: right;
  margin-top: 49px;
  box-shadow: 0 1px 1px rgba(0,0,0,0.4);
  font-size: 0.8175rem;
  color: white;
  border-radius: 5px;
  padding: 3px 7px;
  margin-right: -5px;
}
</style>
